export default __webpack_public_path__ + "static/media/CHEM.decece0d.jpg";